import { createFileRoute } from '@tanstack/react-router'
import EditionSalesSheetSearch from 'Edition/components/search/EditionSalesSheetSearch'

export const Route = createFileRoute('/_editionsearch/work/salessheet')({
    validateSearch: (search: Record<string, string>) => search,
    component: EditionSalesSheetSearch,
})
